{
	"current_lang": "EN",
	"shared_mailbox": "Shared mailboxes",
	"shared_mailbox_description": "<strong>One email address, one team.</strong><br>Create a team address and manage it together: every teammate can send and receive messages with this address without leaving their Gmail interface.",
	"service_account": "Service accounts",
	"service_account_description": "<strong>Drive your service accounts.</strong><br> A service account is a technical identity used by an application or a script to access Google services without human intervention. It allows you to centralize your shared resources and secure your automated tasks among authorized members.",
	"account_health": "Account health",
	"account_health_description": "<strong>Make sure everything is in order.</strong><br>Check that all your identity information is properly synced.",
	"account_health_no_access_message_title": "Sorry, you do not have access to account health management.",
	"account_health_no_access_message_description": "To become an account health manager, you must request access ",
	"associated_site_resource_management": "Management of Sites and their Associated Resources",
	"site_resource_management": "Management of Sites and their Resources",
	"site_resource_management_description": "Manage your sites and all their resources: rooms, equipment, vehicles…",
	"resource_management_mygoogle": "MyGoogle Resource Management",
	"resource_associated": "Associated resource",
	"resource_details": "Resource Details",
	"resource_management_description": "<strong>Centralize your site management in one place.</strong><br>Create buildings, configure each room and its equipment, manage calendar access, and export site data in just a few clicks.",
	"resource_management_calendar_admin": "Admin Resource Management",
	"resource_management_calendar_admin_description": "You will be able to see and modify events from a resource's calendar on Google Calendar. Choose your building and select your resource !",
	"resource_associated_deleted": "List of associated resources to delete ({ressourcesNumber})",
	"resource_calendar_admin_access": "Resource calendar admin access",
	"resource_calendar_admin_access_description": "<strong>Master your resource scheduling.</strong><br>Set admin rights on a calendar resource to manage and modify events directly within Google Calendar.",
	"create_shared_mailbox": "Create a shared mailbox",
	"create_shared_mailbox_success": "Shared mailbox created",
	"create_shared_mailbox_success_description": "The shared mailbox has been successfully created",
	"shared_mailbox_creation_in_progress": "Shared mailbox creation",
	"shared_mailbox_creation_step_message_1": "The shared mailbox is being created, this may take a few minutes. Here are the current steps",
	"shared_mailbox_creation_step_message_2": "You can keep this page open while creation is in progress. You can add delegates once creation is complete.",
	"shared_mailbox_creation_steps": "Shared mailbox creation steps",
	"shared_mailbox_creation_step_label": "Step {step}",
	"edit_shared_mailbox": "Edit a shared mailbox",
	"edit_shared_mailbox_title": "Edit shared mailbox \"{name}\"",
	"visualize_shared_mailbox_title": "Visualize shared mailbox \"{name}\"",
	"edit_the_mailbox": "Edit the mailbox",
	"edit_shared_mailbox_success": "Shared mailbox edited",
	"edit_shared_mailbox_success_description": "The shared mailbox has been successfully edited",
	"renew_shared_mailbox_success": "The shared mailbox has been successfully renewed",
	"delete_shared_mailbox_success": "Shared mailbox deleted",
	"delete_shared_mailbox_success_description": "The shared mailbox has been successfully deleted",
	"create_mailbox": "Create a mailbox",
	"cancel": "Cancel",
	"reminder": "Reminder",
	"reminder_message_shared_mailbox": "<strong>One email address, one team.</strong><br>Create a team address and manage it together: every teammate can send and receive mails with this address without leaving their Gmail interface.",
	"reminder_create_shared_mailbox": "A quick check-in every 6 months.",
	"reminder_create_shared_mailbox_message": "By default, your shared mailbox is active for 6 months.<br> Don’t worry, we’ll send you an email as the deadline approaches. If no action is taken, the mailbox will be automatically deleted to keep things clean.",
	"address": "Address",
	"description": "Description",
	"type": "Type",
	"create_shared_mailbox_form_adress": "The address of your shared mailbox.",
	"create_shared_mailbox_form_description": "What's the purpose of this mailbox and who is it intended for?",
	"create_shared_mailbox_form_description_placeholder": "What's the purpose of this mailbox and who is it intended for?",
	"create_shared_mailbox_form_delegate": "Delegates can edit or delete this shared mailbox.",
	"expired": "Expired",
	"imminent": "Imminent",
	"status_expired": "Expired",
	"status_imminent": "Imminent",
	"expiration": "Expiration",
	"expire": "Expire",
	"expire_on": "expires on",
	"owners": "Owners",
	"owner": "Owner",
	"holder": "Owner",
	"holder_right_description": "manager rights + account responsible (billing...)",
	"managers": "Managers",
	"manager": "Manager",
	"manager_right_description": "members rights + change owner",
	"delegate": "Delegate",
	"delegates": "Delegates",
	"days": "days",
	"in": "in",
	"delete": "Delete",
	"edit": "Edit",
	"create": "Create",
	"see_detail": "See details",
	"renew": "Renew",
	"delete_message": "Do you want to delete this shared mailbox: {mail}?",
	"empty_shared_mailbox": "You don't have a shared mailbox yet...",
	"delete_shared_mailbox": "Delete shared mailbox",
	"delete_mailbox": "Delete mailbox",
	"add_delegates": "Add delegates",
	"add": "Add",
	"back": "Back",
	"scroll_up": "Scroll up",
	"scroll_down": "Scroll down",
	"scroll_position": "Scroll position",
	"search_and_add_delegates": "Find and add delegates to your shared mailbox",
	"add_by_name": "Add by name, UUID...",
	"add_by_email": "Add by email",
	"email_not_found": "Email not found",
	"email_already_added": "Email already added",
	"search_by_name": "Search by name, UUID...",
	"search_by_country": "Add by country...",
	"search_by_building": "Add by building...",
	"search_by_department": "Add by department...",
	"search_by_job": "Add by job...",
	"search_by_contract": "Add by contract...",
	"search_by_role": "Add by role...",
	"search_by_mission": "Add by mission...",
	"search_by_service": "Add by service...",
	"search_shared_mailbox": "Search a shared mailbox",
	"search_no_result": "No result",
	"delete_delegate": "Remove delegate",
	"delete_delegate_message": "Do you want to delete the following delegate: {mail}?",
	"delegate_form_message": "Reminder: delegates can modify and renew this shared mailbox.",
	"description_form_message": "What is the purpose of this mailbox and who is it intended for ?",
	"renew_title": "Renew shared mailbox",
	"renew_message": "Do you want to renew this shared mailbox: {mail}?",
	"home_page_title": "Welcome to MyGoogle.",
	"home_page_welcome_title": "Welcome on MyGoogle",
	"home_page_description": "With MyGoogle, discover the advanced features of your Google account, such as the management of shared mailboxes, mailing lists and service accounts!",
	"later": "Later",
	"finish": "Finish",
	"expiration_form_title": "Expiration",
	"expiration_form_message": "Reminder: A shared mailbox has a lifespan of 6 months. If necessary, you can extend this period by a further 6 months as the expiration date approaches.",
	"expiration_form_message_SA": "Reminder: A service account has a lifespan of 6 months. If necessary, you can extend this period by a further 6 months as the expiration date approaches.",
	"domain": "Domain",
	"name": "Name",
	"add_delegate_to_shared_mailbox": "Add delegates to your shared mailbox",
	"delagates_title_information": "Your shared mailbox is now created, you can now add delegates to it if you wish.",
	"delagates_title_information_message": "A delegate will have the possibility of consulting the shared mailbox, modifying it and renewing it. You will be the only one who can delete it.",
	"loading": "Loading",
	"close_modal": "Close modal",
	"close": "Close",
	"banner_notification_access": "Notifications",
	"banner_notification_view_details": "See details",
	"close_alert": "Close alert",
	"navigate": "Navigate",
	"no_description": "No description",
	"no_expiration_date": "No expiration date",
	"my_shared_mailbox": "My shared mailboxes",
	"other_shared_mailbox": "Search for a mailbox",
	"profile": "Profile",
	"home": "Home",
	"menu": "Menu",
	"mail": "Mail",
	"address_placeholder_SM": "Enter the name of the shared mailbox here",
	"address_placeholder_SAA": "Enter the name of the service account here",
	"invalid_email_format": "Invalid email format",
	"invalid_email_format_desc": "Email format must be firstname.lastname@decathlon.com",
	"group_name_placeholder": "group name",
	"create_service_account": "Create a service account",
	"create_the_service_account": "Create the service account",
	"edit_service_account": "Edit a service account",
	"edit_service_account_title": "Edit service account \"{name}\"",
	"edit_the_service_account": "Edit the service account",
	"visualize_service_account": "Visualize a service account",
	"visualize_service_account_title": "Visualize service account \"{name}\"",
	"edit_service_account_success": "Service account edited",
	"edit_service_account_success_description": "The service account has been successfully edited",
	"reminder_create_service_account": "A quick check-in every 6 months.",
	"reminder_create_service_account_message": "By default, your service account is active for 6 months.<br> Don’t worry: we’ll shoot you an email as the deadline approaches. If no action is taken by the manager or team members, the account will be automatically deleted to keep things tidy.",
	"create_service_account_form_name": "The address of your service account.",
	"create_service_account_form_description": "What is the purpose of this service account and who is it for ?",
	"create_service_account_form_description_placeholder": "What is the purpose of this service account and who is it for ?",
	"create_service_account_success": "Service account created",
	"create_service_account_success_description": "The Service Account has been successfully created",
	"error_title": "Error",
	"error_mandatory_name": "The Name is mandatory",
	"error_mandatory_description": "The Description is mandatory",
	"invalid_name_format": "Invalid name format",
	"invalid_name_format_desc": "Name format must be name.name@decathlon.com",
	"error_conflict": "Conflict",
	"error_conflict_description": "Name already exists",
	"error_standard": "An error has occured",
	"name_too_short": "Name too short, minimum 3 characters required",
	"description_help": "Description of at least 5 understandable characters.",
	"member": "Member",
	"members": "Members",
	"member_right_description": "see and connect",
	"members_form_message": "Reminder: Members can edit service account members.",
	"members_title_information": "Your service account is now created, you can now add members to it if you wish",
	"members_title_information_message": "A member will have the ability to log in to the service account, modify and renew it. You will be the only one who can delete it.",
	"delete_member": "Delete the member",
	"downgrade": "Downgrade",
	"delete_manager_role": "Delete the manager role",
	"add_member_to_service_account": "Add members to your service account",
	"delete_member_message": "Do you want to delete the following member: {mail}?",
	"delete_manager_role_message": "Do you want to delete the following manager role: {mail}?",
	"delete_manager_warning_message": "Warning: Deleting the manager will not remove it from the members list.",
	"no_results_found": "No results found.",
	"reminder_service_account_message": "<strong>Team power.</strong><br> A service account allows your tools to act automatically with Google services. It also helps centralize access to shared resources for your team. <br><em>Good to know: For security reasons, a temporary password will be generated each time you log in.</em>",
	"my_service_accounts": "My service accounts",
	"delete_service_account": "Delete service account",
	"empty_service_account": "You’re part of no Service Account",
	"renew_service_account_title": "Renew service account",
	"renew_service_account_message": "Do you want to renew this service account: {mail}?",
	"delete_service_account_message": "Do you want to delete this service account: {mail}?",
	"renew_service_account_success": "The service account has been successfully renewed",
	"delete_service_account_success": "Service account deleted",
	"delete_service_account_success_description": "The service account has been successfully deleted",
	"to_connect": "To log in",
	"extend": "Extend",
	"connect_service_account_title": "Service account login ID",
	"connect_service_account_description_part_1": "To access your service account, it is important to log in '<b>private browsing (Ctrl+Shift+N)</b>' mode to the following link:",
	"connect_service_account_description_part_2": "and use the connection details below. They are only valid for 15 minutes.",
	"email": "Email",
	"password": "Password",
	"copy": "Copy",
	"copied": "Copy successful !",
	"search_service_account": "Search a service account",
	"search_group": "Search a group",
	"group_ex_list": "Groups (ex distribution list)",
	"groups": "Groups",
	"group": "Group",
	"group_display_modes": "Group display mode",
	"group_display_list": "Display groups as a list",
	"group_display_cards": "Display groups as cards",
	"group_display_mini_cards": "Display groups as mini cards",
	"display_mode_modes": "Display mode",
	"display_mode_list": "Display as a list",
	"display_mode_cards": "Display as cards",
	"display_mode_mini_cards": "Display as mini cards",
	"group_description": "<Strong>Teamwork made easy.</Strong><br/> Create and manage a single email address to bring a list of users together. It’s the perfect tool for sharing documents, syncing calendars and their associated events, or reaching a defined group in a chat space.",
	"group_description_placeholder": "The purpose of this group and who is it for",
	"create_group": "Create a group",
	"create_group_add_managers_title": "Add managers to your group",
	"group_managers_description": "Managers can edit or delete this group.",
	"reminder_create_group": "A few rules for your group:",
	"reminder_create_group_step_3": "A group is limited to 2500 members unless you are a communicator.",
	"reminder_create_group_message_list_1": "<strong>You can manage up to 2,500 members:</strong> Whether they are added via dynamic filters or manually (static members), your group will last for six months.",
	"reminder_create_group_message_list_1_without_dynamic": "<strong>You can manage up to 2,500 members:</strong> By adding members manually (static members), your group will last for six months.",
	"reminder_create_group_message_step_3_list_1": "A static member will need to be managed manually by the group's managers.",
	"reminder_create_group_message_list_2": "<strong>Keep an eye on the deadline:</strong> We will email you before the end of the six months, but do not hesitate to take action beforehand to avoid the group being deleted.",
	"reminder_create_group_message_list_3": "<strong>Choose the group type carefully:</strong> This choice is permanent. To change the format, you will need to create a new group.",
	"reminder_create_group_message_list_3_without_dynamic": "<strong>Your group will be static:</strong> Members will be added and managed manually by the group's managers.",
	"reminder_create_group_add_managers": "A manager will have the same right as you on the group",
	"reminder_create_group_add_managers_message_list_1": "He can modify the group and add new members",
	"reminder_create_group_add_managers_message_list_2": "He can delete the group",
	"reminder_create_group_message_step_3_list_2": "You will be notified by email as the deadline approaches. Without action from managers, the group is automatically deleted.",
	"reminder_create_group_message_step_3_list_2_without_dynamic": "You will be notified by email before the deadline. Without action from managers, the group is automatically deleted.",
	"create_group_form_name": "The address of your group, without uppercase and without accent.",
	"create_group_form_description": "What is the purpose of this group and who is it for ?",
	"create_group_form_type": "The different group types:<br><br>• <strong>Static groups</strong>: Add members manually, one by one. This is the ideal solution if you want full control over your list, as it only changes when you decide.<br><br>• <strong>Dynamic groups</strong>: Set your own filters and let the list update on its own: members evolve based on your criteria, with no effort on your part.",
	"group_type_description_title": "<strong>The different group types:</strong>",
	"group_type_description_static": "<strong>Static groups:</strong> Add members manually, one by one. This is the ideal solution if you want full control over your list, as it only changes when you decide.<br/><br/>",
	"group_type_description_dynamic": "<strong>Dynamic groups:</strong> Set your own filters and let the list update on its own: members evolve based on your criteria, with no effort on your part.",
	"save_the_description": "save the description",
	"edit_group": "Edit the group",
	"visualize_group": "Visualize the group",
	"create_the_group": "Create the group",
	"create_group_static_success": "Static group created",
	"create_group_static_success_description": "The static group has been successfully created",
	"create_group_dynamic_success": "Dynamic group created",
	"create_group_dynamic_success_description": "The dynamic group has been successfully created",
	"empty_group": "You don't have any groups",
	"renew_group_title": "Renew group",
	"renew_group_message": "Do you want to renew this group: {mail}?",
	"renew_group_succeess": "The group has been successfully renewed",
	"delete_the_group": "Delete the group",
	"edit_the_group": "Edit group",
	"manage_the_group": "Manage group",
	"delete_group_message": "Do you want to delete this group : {mail} ?",
	"delete_group_success": "Group deleted",
	"delete_group_success_description": "The group has been successfully deleted",
	"create_static_group": "Create a static group",
	"create_dynamic_group": "Create a dynamic group",
	"next": "Next",
	"managers_form_message": "Managers can edit or delete this group",
	"add_members": "Add members",
	"manage_members": "Manage members",
	"create_group_form_add_members_static_group": "Allows adding/removing static members",
	"create_group_form_add_members_dynamic_group": "Allows adding/removing static members or filters",
	"add_static_members": "Add static members",
	"manage_static_members": "Manage static members",
	"delete_static_members": "Delete static members",
	"add_static_members_description_modal": "Find and add people as static members for your group",
	"delete_static_members_description_modal": "Find and delete people as static members for your group",
	"add_static_members_description": "Allows you to add/remove static members.",
	"add_dynamic_members": "Add dynamic members",
	"manage_dynamic_members": "Manage your dynamic members !",
	"add_dynamic_members_description": "Add or remove members in just a few clicks using filters.",
	"add_dynamic_members_description_information": "<strong>Please note:</strong> Changing your filters directly impacts your member list. The more criteria you add, the more targeted and restricted your selection becomes.",
	"filter_by_managers": "Filter by managers",
	"filter_by_jobs": "Filter by jobs",
	"filter_by_countries": "Filter by countries",
	"filter_by_buildings": "Filter by buildings",
	"filter_by_departments": "Filter by departments",
	"filter_by_sports": "Filter by sports",
	"filter_by_contracts": "Filter by contracts",
	"filter_by_roles": "Filter by roles",
	"filter_by_missions": "Filter by missions",
	"filter_by_services": "Filter by services",
	"import": "Import",
	"massive_import": "Massive import",
	"massive_import_modal_title": "Bulk import group members",
	"search_and_add_managers": "Find and add managers for your group",
	"search_and_add_countries": "Find and add countries for your group",
	"search_and_add_buildings": "Find and add buildings for your group",
	"search_and_add_departments": "Find and add departments for your group",
	"search_and_add_jobs": "Find and add jobs for your group",
	"search_and_add_contracts": "Select one or more contract type(s) to filter in the member list.",
	"search_and_add_roles": "Find and add roles for your group",
	"search_and_add_missions": "Find and add missions for your group",
	"search_and_add_services": "Find and add services for your group",
	"edit_managers_success": "Managers edited",
	"edit_countries_success": "Countries edited",
	"edit_buildings_success": "Buildings edited",
	"edit_departments_success": "Departments edited",
	"edit_jobs_success": "Jobs edited",
	"edit_contracts_success": "Contracts edited",
	"edit_roles_success": "Roles edited",
	"edit_missions_success": "Missions edited",
	"edit_services_success": "Services edited",
	"edit_managers_success_description": "Manager filters have been successfully edited.",
	"edit_countries_success_description": "Country filters have been successfully edited.",
	"edit_buildings_success_description": "Building filters have been successfully edited.",
	"edit_departments_success_description": "Department filters have been successfully edited.",
	"edit_jobs_success_description": "Job filters have been successfully edited.",
	"edit_contracts_success_description": "Contract filters have been successfully edited.",
	"edit_roles_success_description": "Roles filters have been successfully edited.",
	"edit_missions_success_description": "Missions filters have been successfully edited.",
	"edit_services_success_description": "Services filters have been successfully edited.",
	"add_people": "Add people",
	"my_groups": "My groups",
	"groups_im_part_of": "Groups including me",
	"edit_group_success": "Group edited",
	"edit_group_success_description": "The group has been successfully edited",
	"delete_manager_success": "Manager deleted",
	"delete_manager_success_description": "The manager has been successfully deleted",
	"add_manager_success": "Manager added",
	"add_manager_success_description": "The manager has been successfully added",
	"add_manager_process_success_description": "Your request is being processed. The manager will be available in a few minutes",
	"group_details": "Group details",
	"members_list": "Members list",
	"country_not_found": "No countries found",
	"select_one_file": "Select one file",
	"confirm": "Confirm",
	"import_progress": "Import in progress",
	"massive_import_information": "and replace only the example emails with your list of email addresses.",
	"download_our_template": "Download our template",
	"massive_import_information_2": "Then import the file and confirm the upload.",
	"massive_import_drag_and_drop_message": "Drag your file to start uploading",
	"massive_import_file_type": "Supported format:",
	"massive_import_wrong_file_type_title": "Importation error",
	"massive_import_wrong_file_type_description": "File type not supported. Use a .csv file.",
	"first_step_massive_import": "Select one file with the list of group member (email)",
	"third_step_massive_import": "Wait for the mail that will prevent you that the group is ready before seeing the group updated. You can click on Finish.",
	"massive_import_success": "Massive import completed",
	"massive_import_success_description": "The massive import was successfully completed",
	"massive_import_success_message": "Wait for the mail that will prevent you that the group is ready before seeing the group updated !",
	"massive_import_alert_2500_members": "The list of members exceeds 2500. Try another file or update the current list.",
	"search_group_member": "Search for a group member (3 characters minimum)",
	"add_member_success": "Member added",
	"add_member_success_description": "The member has been added successfully",
	"delete_member_success": "Member deleted",
	"delete_member_success_description": "The member has been successfully deleted",
	"add_delegate_success": "Delegate added",
	"add_delegate_success_description": "The delegate has been successfully added",
	"delete_delegate_success": "Delegate deleted",
	"delete_delegate_success_description": "The delegate has been successfully deleted",
	"edit_sa_role_member_success": "Member role edited",
	"edit_sa_role_member_success_description": "The member role has been successfully edited",
	"manage_managers": "Manage managers",
	"manage_countries": "Manage countries",
	"manage_buildings": "Manage buildings",
	"manage_departments": "Manage departments",
	"manage_jobs": "Manage jobs",
	"manage_contracts": "Choose the type of contract in the selection criteria.",
	"manage_roles": "Manage roles",
	"manage_missions": "Manage missions",
	"manage_services": "Manage services",
	"save": "Save",
	"dark_mode_actived": "Dark mode is activated",
	"light_mode_activated": "Light mode activated",
	"theme_mode_light": "Light",
	"theme_mode_dark": "Dark",
	"redirected_to": "redirected to",
	"english": "English",
	"French": "French",
	"selecte_language": "Select language",
	"selected_language": "Selected language",
	"shared_mailbox_description_label": "Description of the shared mailbox",
	"group_description_label": "Description of the group",
	"saa_description_label": "Description of the service account",
	"shared_mailbox_status_label": "Status of the shared mailbox",
	"saa_status_label": "Status of the service account",
	"modify_shared_mailbox_description": "Edit the shared mailbox description",
	"modify_saa_description": "Edit the service account description",
	"modify_group_description": "Edit the group description",
	"extend_lifespan_of_shared_mailbox": "Extend the lifespan of the shared mailbox by an additional 6 months",
	"extend_lifespan_of_saa": "Extend the lifespan of the service account by an additional 6 months",
	"members_list_shared_mailbox": "Members list of the shared mailbox",
	"members_list_saa": "Members list of the service account",
	"members_list_group": "Members list of the group",
	"member_role": "Role of the member",
	"search_&_add_new_person": "Search and add a new {role} by name, email, or UID",
	"search": "Search",
	"add_owner_shared_mailbox": "Add a new owner",
	"become_the_new_owner": "Become the new Owner",
	"go_back_previous_screen": "Go back to the previous screen",
	"empty_delegates_list_title": "Become the new owner of the Sharemailbox",
	"empty_delegates_list_message": "Ooops, this sharemailbox can’t be managed as it has no more owner. To continue, you have to become the owner or request the owner to connect on this screen.",
	"add_new_owner_shared_mailbox_success_title": "New owner added",
	"add_new_owner_shared_mailbox_success_description": "The new owner has been added successfully.",
	"email_or_uid": "Email or UID",
	"display_name": "Display Name",
	"primary_address": "Primary Address",
	"job": "Job",
	"branch": "Branch",
	"country": "Country",
	"site_name": "Site Name",
	"aliases": "Aliases",
	"is_boss": "Is Boss",
	"creation_date": "Creation Date",
	"last_login_date": "Last Login Date",
	"contract_type": "Contract Type",
	"state": "State",
	"2_step_authent": "2 Step Authent",
	"mobile_infos": "Infos Mobile",
	"possible_actions": "Possible Actions",
	"buildings": "Buildings",
	"buildings_management": "Management of Sites and their associated Resources",
	"buildings_management_reminder": "Only users with \"MyGoogle - Site Management\" role on Identity Access can edit or delete a building. To become site manager, request it on ",
	"buildings_management_description": "<strong>Lead your workspace with ease.</strong><br>You can create and edit sites and resources (meeting rooms, IT hardware, shared vehicles, and more) whenever you need.",
	"building_create": "Creation of a new Site",
	"building_new_create": "Create a new building",
	"building_creation_success": "Creation done",
	"building_creation_success_description": "The building has been created successfully.",
	"building_reminder_description": "Only Display mode activated as you’re not a site manager.",
	"building_form_id_description": "The building id is the combination of Countrycode-City-SiteName, building-id: {buildingId}",
	"building_form_adress_description": "Copy paste the maps address",
	"building_form_areas_floors_description": "Are used to group your rooms in your site to help the users to find them quickly.. It can be floors, cardinal points, …",
	"building_form_areas_floors_placeholder": "Areas & floors separated by coma “,”",
	"building_before_deletion_title": "Before you can delete the site {building} :",
	"building_delete": "Delete the Site",
	"building_deletion_title": "Do you really want to delete the site {building} ?",
	"building_deletion_watch_out": "This choice is final, you cannot go back.",
	"building_deletion_resources": "This action will delete all resources associated with <span class=\"vtmn-font-bold\">{building}</span>.",
	"building_deletion_warning": "WARNING: This choice is final, you will not be able to go back. This action may take a few minutes depending on the number of resources to be deleted.",
	"building_deletion_site_details": "Here are the details of this site",
	"building_deletion_success": "Building deleted",
	"building_deletion_success_description": "The building \"{buildingId}\" has been successfully deleted.",
	"building_display_information_first": "Only users with the",
	"building_display_information_second": "access on the",
	"building_display_information_third": "tool can modify or delete a Site.",
	"building_display_information_end": "To become a Site Manager, do not hesitate to apply on",
	"building_creation_building_id_helper_text": "The building ID is the combination of Countrycode-City-SiteName",
	"building_floors_placeholder": "Please separate floors with a comma (0, 1, 2...)",
	"building_floors_helper_text": "Very useful for grouping your site's Resources. It will help Teammates find them more easily.",
	"building_address_helper_text": "Copy the full address from Google Maps",
	"building_address": "Site Address",
	"building_address_placeholder": "Paste the address here",
	"building_name_placeholder": "Enter the name of the Site here",
	"building_city_placeholder": "Add the city here",
	"building_country_code": "Country code",
	"building_creation_information": "Once the site is created, its ID cannot be changed. Take a moment to double-check that everything is correct before confirming.<br>⚠️ Warning: Do not include the country code or city in the \"Site Name\" field. This information has already been entered in the two previous fields.",
	"building_creation_no_rights_title": "You do not have the necessary rights to create a site.",
	"building_creation_no_rights_description": "To become a Site Manager/Editor, you need to request access to ",
	"building_edit_title": "Edit the Site \"{name}\"",
	"building_edit_breadcrumb": "Edit the Site",
	"building_name": "Site Name",
	"building_id_title": "Id (Automatic Generation)",
	"building_id_text": "The building ID is the combination of Countrycode-City-SiteName",
	"building_floors_text": "Very useful for grouping your site's Resources. It will help Teammates find them more easily.",
	"building_address_text": "Copy the full address from Google Maps",
	"building_associated": "Associated Site",
	"building_country_code_invalid": "Invalid country code",
	"automatic_generation": "Automatic generation",
	"create_the_building": "Create the building",
	"search_building": "Search a building",
	"search_building_empty": "No building found",
	"search_resource": "Search resources",
	"calendar_admin_description_first": "Become manager/editor of buildings resources'calendar.",
	"calendar_admin_description_second": "You'll be able to see and modify events on a resource's calendar in Google Calendar.",
	"calendar_admin_description_third": "Just look for the building, and the list of the building's resources will appear. Just slide them !",
	"exit": "Exit",
	"country_code": "Country code",
	"city": "City",
	"floors": "Floors",
	"maps_address": "Maps Address",
	"2_letters": "2 letters",
	"internal_city_name": "Internal city name",
	"watch_out": "Watch out",
	"resource_management": "resource management",
	"alert_group_2500_members_message": "<strong>Full house!</strong><br/> Your group has reached its maximum capacity of 2,500 members. It is not possible to add any more members at this time.",
	"i_understand": "I understand",
	"internal_building_name": "Internal Building Name",
	"list_being_calculated": "The list is being calculated. Please refresh the page in <span class=\"colorWarning\">{countdownTime} second(s)</span> to see the effective update.",
	"refresh": "Refresh",
	"or": "OR",
	"thanks": "Thanks !",
	"understand": "I understand",
	"dynamic_group_description": "To set up your group, simply specify your criteria (country, building, job...). <br><br>Members are updated automatically: as soon as someone matches your filters, they’re in! If they no longer meet the criteria, they are removed. <br><br>An exception? You can still add members manually, but keep in mind they will be managed statically.",
	"static_group_description": "Add your members manually and stay in full control. <br><br><strong>Quick reminder:</strong> you'll be responsible for updating the list yourself if your group changes.",
	"groups_error_422_banner_message_1": "Watch out: Current filters could not be resumed.",
	"groups_error_422_banner_message_2": "You have two options:",
	"groups_error_422_banner_message_3": "Recreate them below",
	"groups_error_422_banner_message_4": "Abort editing the group to not change the current filters by pressing the 'Finish' button available at the bottom of the page.",
	"massive_import_reading_file_error": "Error reading the file.",
	"contract_type_cdi": "Permanent contract (CDI)",
	"contract_type_cdd": "Fixed-term contract (CDD)",
	"contract_type_intern": "Intern",
	"contract_type_provider": "Provider",
	"contract_type_franchise": "Franchise",
	"contract_type_temp": "Temporary (Interim)",
	"contract_type_generic": "Generic",
	"previous": "Previous",
	"required_fields": "*Required fields",
	"description_too_short": "Description too short (5 characters minimum)",
	"search_unavailable": "Search unavailable",
	"search_down_banner_message": "The search feature is currently unavailable. You can manually add the person's email address.",
	"manager_not_found": "Manager not found",
	"errors.multiple_detected": "There are {count} errors. Try again later.",
	"warnings.multiple_detected": "There are {count} warnings. Try again later.",
	"information.multiple_detected": "There are {count} informations.",
	"errors.see_details": "View errors",
	"warnings.see_details": "View warnings",
	"success.see_details": "View successes",
	"information.see_details": "View information",
	"errors.list_description": "Here are the details of the errors",
	"errors.list_title": "Error summary",
	"warnings.list_description": "Here are the details of the warnings",
	"warnings.list_title": "Warning summary",
	"error.copied": "Error successfully copied",
	"success.multiple_detected": "{count} successes detected",
	"success.list_title": "Success summary",
	"success.list_description": "Here are the details of the successes",
	"information_list_title": "Information summary",
	"information_list_description": "Here are the details of the information",
	"accounthealth_info": "<strong>Keep an eye on your account health.</strong><br>This information helps identify errors if there's a glitch. Take a look at your data: if something doesn't look right, get in touch with your manager to check in.",
	"3_characters_minimum": "You must enter at least 3 characters to launch the search.",
	"error_address_mismatch": "The main addresses are not identical between the LDAP and Google directories. This needs to be corrected to ensure that the services work properly.",
	"error_alias_mismatch": "The aliases are not identical between the LDAP and Google directories. This needs to be corrected to ensure that the services work properly.",
	"error_internal_serve": "An internal server error has occurred, please try again later.",
	"administrator": "Administrator",
	"admin_dashboard_access": "Admin dashboard",
	"admin_guard_error": "An error occurred while checking your permissions.",
	"admin_banner_page_title": "Information banners management",
	"admin_banner_existing_title": "Existing banners",
	"admin_banner_new": "New banner",
	"admin_banner_column_id": "ID",
	"admin_banner_column_title": "TITLE",
	"admin_banner_column_message": "MAIN MESSAGE",
	"admin_banner_column_type": "TYPE",
	"admin_banner_column_status": "STATUS",
	"admin_banner_column_actions": "ACTIONS",
	"admin_banner_status_active": "Active",
	"admin_banner_status_inactive": "Inactive",
	"admin_banner_edit_aria": "Edit",
	"admin_banner_delete_aria": "Delete",
	"admin_banner_empty_message": "No banner has been created yet.",
	"admin_banner_modal_title_edit": "EDIT BANNER",
	"admin_banner_modal_title_create": "CREATE A NEW BANNER",
	"admin_banner_form_error_required": "Please fill in the banner title and message.",
	"admin_banner_form_title_label": "Banner title *",
	"admin_banner_form_title_placeholder": "e.g.: Store closure announcement",
	"admin_banner_form_message_label": "Message text *",
	"admin_banner_form_message_placeholder": "Enter the banner message here...",
	"admin_banner_form_type_label": "Alert type *",
	"admin_banner_action_cancel": "Cancel",
	"admin_banner_action_update": "Update",
	"admin_banner_action_create": "Create banner",
	"banner_type_information": "Information",
	"banner_type_warning": "Warning",
	"banner_type_danger": "Error",
	"banner_type_success": "Success",
	"teammate": "Teammate",
	"site_manager": "Site Manager",
	"sync_data": "Synchronise",
	"groups_email_send_warning": "The group has more than 2500 members, you cannot enable this option. Only a communication manager can authorize its use to send emails. They must be the group manager to do so.",
	"groups_enable_email_sending": "Activate email sending on this group",
	"groups_email_sending": "Email sending",
	"groups_email_sending_enable_success": "Email sending has been successfully activated.",
	"groups_email_sending_disable_success": "Email sending has been successfully deactivated.",
	"groups_email_sending_description": "If this option is not enabled, you can still share files to collaborate, send appointments to the group, etc...",
	"filter_change_desactivate_email_send_message": "Warning, once the filter is applied, sending emails to this group will be blocked. Once the member list is recalculated, you will need to reactivate email sending for the group.",
	"membership_calculation_in_progress": "The member list is still being calculated, this feature is therefore not active.",
	"calculation_in_progress": "Calculation in progress!",
	"calculation_in_progress_description": "Adjusting the member list... Please wait a few seconds.",
	"need_help": "NEED HELP?",
	"contact_support": "Contact our support",
	"find_dct_site": "Find our DCT site",
	"is": "is",
	"are": "are",
	"creation_in_progress": "currently being created",
	"creation_groups_in_progress_link": "Here are the links to the groups currently being created",
	"groups_creation_in_progress": "Groups currently being created",
	"groups_creation_step_message_1": "The group is being created, this may take a few minutes. Here are the current steps",
	"groups_creation_step_message_2": "You can keep this page open while the creation is in progress and refresh it from time to time. Once the creation steps are finished, you will be able to manage the group members via the dedicated editing page.",
	"see_the_group": "See the group",
	"see_the_groups": "See the groups",
	"group_creation_step_1": "Group creation",
	"group_creation_step_2": "Adding as a member",
	"group_creation_step_3": "Updating security settings",
	"group_creation_step_4": "Adding as the group manager",
	"group_creation_step_5": "Group creation completed",
	"service_account_creation_in_progress": "Service account creation",
	"service_account_creation_step_message_1": "The service account is being created, this may take a few minutes. Here are the current steps",
	"service_account_creation_step_message_2": "You can keep this page open while creation is in progress. You can add members once creation is complete.",
	"service_account_creation_steps": "Service account creation steps",
	"service_account_creation_step_label": "Step {step}",
	"site_data_extraction": "Extracting data from a site",
	"site_data_extraction_description": "<strong>Your insights, ready to go.</strong><br>Easily extract all event and cost data for a site over any period. This tool gives you everything you need to track and analyze your site’s activity.",
	"site_data_extraction_reminder": "Extract all event and cost data for a site over a specific date range. You can also choose to filter the export for a single resource only.",
	"search_site_information_message": "Search for a Site to find the data you want to extract.",
	"search_site_information_message_first": "First, search for a site.",
	"search_site_information_message_second": "Then access the management of Resources associated with this Site.",
	"search_site_calendar_admin_information_message": "Search for a Site to find the Rooms you want to enable.",
	"download": "Download",
	"extract_other_data": "Extract other data",
	"access_gmail": "Access gmail",
	"site": "Site",
	"site_data_extracted_information_without_resource": "Site \"{selectedBuildingName}\" on the range from {startDate} to {endDate}",
	"site_data_extracted_information_with_resource": "Resource \"{selectedResource}\" of site \"{selectedBuildingName}\" on the range extending from {startDate} to {endDate}",
	"site_data_extracted_summary": "Here is the summary of your extraction",
	"site_data_extracted_in_progress": "The data extraction is in progress. You will receive an email with the raw data attached.",
	"site_data_extracted_thanks_message": "Thank you, your extraction is in progress!",
	"site_data_extraction_error_title": "Sorry, there was a problem with the extraction request",
	"site_data_extraction_error_description": "The data extraction request failed, please try again or use a different extraction range. If the problem persists, feel free to create a Ticket.",
	"site_data_extraction_no_access_message_1": "Sorry, you do not have access to site data extraction management.",
	"site_data_extraction_no_access_message_2": "To become a manager of site data extraction, you must request access \"MyGoogle - Site Management\" on Identity Access.",
	"start_date": "Start date",
	"end_date": "End date",
	"open_calendar": "Open calendar",
	"selected_site": "Selected site",
	"resource": "Resource",
	"only_one_resource": "One resource only",
	"choose_the_resource": "Choose the resource",
	"back_to_form": "Back to form",
	"create_smax_ticket": "Create SMAX Ticket",
	"support": "Support",
	"see_associated_resources": "See Associated Resources",
	"modify": "Edit",
	"building_edit_warning_title": "Please note that if you update a site, ensure that the changes do not affect users ability to find resources.",
	"error_floors_invalid_chars_helper": "Only numbers, letters, hyphens and asterisks are authorised.",
	"error_address_invalid_chars_helper": "Only numbers, letters, hyphens and commas are authorised.",
	"building_update_success": "The Site has been successfully modified.",
	"error_update_building": "The modification of the Site has failed.",
	"two_letters": "2 letters",
	"resources_empty_title_message": "There are no Resources on this site yet!",
	"resource_create": "Create a Resource",
	"resource_add": "Add a Resource",
	"resources_associated_to": "Resources associated to {building}",
	"resource_meet_space": "Meeting Space",
	"resource_floor_section": "Floor Section",
	"resource_capacity": "Capacity",
	"resource_billing": "Billing",
	"resource_devices": "Devices",
	"resource_creation_warning_message": "Warning: If you update a Resource, ensure that the changes do not affect the user's ability to find it. Defining resource information, such as building, floor, or capacity, affects automatically generated resource names and room searches. If a Resource is modified, it is automatically removed from the calendar.",
	"resource_other": "Other resource",
	"resource_unknown": "Unreferenced",
	"resource_creation_no_rights_title": "You do not have the necessary rights to create a resource.",
	"resource_features_helper_text": "Don't hesitate to do regular inventories to keep the list up to date.",
	"resource_features_placeholder": "Make sure to separate devices with a comma (projector, screen, ...)",
	"resource_creation_inputs_autorized_letters_helper_text": "Allowed characters: A-Z .-_,&'.",
	"resource_creation_inputs_autorized_numbers_helper_text": "Allowed characters: numbers only.",
	"resource_billing_placeholder": "Enter the billing information here",
	"resource_capacity_placeholder": "Enter the maximum capacity here",
	"resource_type_placeholder": "Enter the resource type here",
	"resource_section_placeholder": "Enter the floor section here",
	"resource_name_placeholder": "Enter the resource name here",
	"resource_category": "Resource Category",
	"resource_category_select": "Select a category",
	"resource_category_room": "Meeting Space (room, phone booth, ...)",
	"resource_category_other": "Other resource (projector, vehicle, ...)",
	"resource_id_auto_generated": "Resource ID auto-generated",
	"resource_id_generation_helper_text": "The ID of a Resource is the combination of siteName-resourceName",
	"resource_floor_select": "Select a floor",
	"resource_associated_not_editable": "Associated site (Not editable)",
	"resource_created_title": "Resource created",
	"resource_created_description": "The resource {resourceName} has been successfully created.",
	"resource_management_calendar_admin_result_title": "Here are the Resources linked to the Site",
	"resource_management_calendar_admin_result_message": "You can now enable calendar management/editing for the Resources you want to link to this Site.",
	"resource_management_calendar_search_placeholder": "Search a Site to access the Admin activation of its resources",
	"resource_management_calendar_admin_title": "<strong>Your calendars, right where you need them.</strong><br>Enable setup rights for the rooms of your choice. You can now access their settings and manage events directly from your Google Calendar.",
	"resource_management_calendar_admin_no_access_message_1": "Sorry, you do not have access to manage the Resources calendar.",
	"resource_management_calendar_admin_no_access_message_2": "To become a manager/editor of the Resources calendar for Sites, you need to request access to ",
	"resource_edit_breadcrumb": "Edit the Resource",
	"resource_edit_title": "Edit the Resource for Site \"{building}\"",
	"resource_update_success_title": "Resource updated",
	"resource_update_success_description": "The Resource {resourceName} has been successfully updated.",
	"resource_update_error_title": "An error occurred while updating the Resource.",
	"no_results_for_building": "No results for \"{selectedBuilding}\"",
	"creation_new_resource": "Create a new Resource",
	"creation_new_resource_of_building": "Create a new Resource for the Site {building}",
	"create_the_resource": "Create the resource",
	"edit_the_resource": "Edit the resource",
	"devices": "Device(s) accompanying the resource (optional)",
	"billing": "Billing",
	"back_home_page": "Back to home",
	"banner_delete_resources_message": "The resources of building \"{buildingId}\" are being deleted. This may take a few minutes.",
	"resource_deletion_title": "Do you really want to delete the Resource \"{resourceName}\" ?",
	"resource_deletion_warning": "<span class=\"vtmn-font-bold\">WARNING</span> : This choice is final, you will not be able to go back.",
	"resource_deletion_details": "Here are the details related to this Resource: {resourceDetails}",
	"resource_deletion_success": "Resource deleted",
	"resource_deletion_success_description": "The Resource has been successfully deleted",
	"too_short_email": "Name too short (3 characters minimum)",
	"identity_access": "Identity Access",
	"access_to_identity_access": "Access to Identity Access",
	"on": "on",
	"mygoogle_support": "MyGoogle - Support",
	"mygoogle_site_management": "MyGoogle - Site Management",
	"search_group_information_message_first": "First, search for a group.",
	"search_group_information_message_second": "Then access its details or management.",
	"group_message": "<strong>Manage your groups easily.</strong><br/> View the groups you belong to and manage those you have rights to directly from this space.",
	"search_sharedmailbox_information_message_first": "First, search for a shared mailbox.",
	"search_sharedmailbox_information_message_second": "Then access its details or management.",
	"search_service_account_information_message_first": "Search for a service account to quickly access its details or settings.",
	"search_group_underscore_warning": "To search for a group whose name contains an underscore (_), be sure to include that underscore in your search",
	"search_group_underscore_example": "(e.g.: search for 'name_' to find 'name_group')",
	"dynamic": "Dynamic",
	"static": "Static",
	"unknown": "Unknown",
	"visualize": "Visualize",
	"dynamic_groups_alert_title": "⚠️ Dynamic groups",
	"dynamic_groups_alert_description": "Dynamic groups modification is exclusive to the <strong>MyGoogle - Communicator</strong> role (automatically assigned to managers, Communication teams, and Office Managers).",
	"dynamic_groups_alert_how_to": "How to proceed?",
	"dynamic_groups_alert_check_role": "Check my role",
	"dynamic_groups_alert_has_role": "Do you have the role?",
	"dynamic_groups_alert_training": "Take the mandatory training",
	"dynamic_groups_alert_no_role": "Don't have the role? Your manager already has it! You can add them as a delegate to manage the group.",
	"dynamic_groups_alert_creation_blocked": "Currently, the creation of dynamic groups is blocked.",
	"dynamic_groups_alert_follow_evolution": "Follow the evolution of dynamic groups and our next steps on this link:",
	"dynamic_groups_alert_dct_site": "DCT Site",
	"meeting_room_manager": "Meeting Room Manager",
	"meeting_room_manager_description": "<strong>Find and book meeting rooms.</strong><br>Search by building, check room availability, and download QR codes for quick reservations.",
	"mrm_step1_title": "Select Building",
	"mrm_step1_description": "Search and select the building where you want to view the live status of the rooms.",
	"mrm_step2_title": "Select Floor & Search",
	"mrm_step2_description": "Choose a floor and search for available rooms.",
	"mrm_next": "Next",
	"mrm_search_buildings_label": "Search buildings",
	"mrm_search_building_placeholder": "Search for a building...",
	"mrm_no_buildings_found": "No buildings found.",
	"mrm_select_floors_optional": "Select floors (optional):",
	"mrm_show_available_rooms_only_label": "Show available rooms only",
	"mrm_downloading": "Downloading...",
	"mrm_download_qr_codes": "Download QR Codes",
	"mrm_show_rooms": "Show rooms",
	"mrm_please_select_building_first": "Please select a building first.",
	"mrm_qr_codes_downloaded_success": "QR Codes downloaded successfully",
	"mrm_qr_codes_download_failed": "Failed to download QR Codes",
	"mrm_rooms_page_title": "{buildingName} — Rooms",
	"mrm_no_rooms_found": "No rooms found.",
	"mrm_no_rooms_found_description": "There are no meeting rooms to display for this building.",
	"mrm_auto_scroll_label": "Auto-scroll",
	"mrm_free": "Free",
	"mrm_available_at": "Available at {time}",
	"mrm_confirm_reservation_title": "Confirm Reservation",
	"mrm_reservation_confirmed": "Reservation Confirmed",
	"mrm_back_to_meeting_room_manager": "Back to Meeting Room Manager",
	"mrm_room_label": "Room:",
	"mrm_start_date": "Start Date",
	"mrm_start_time": "Start Time",
	"mrm_end_date": "End Date",
	"mrm_end_time": "End Time",
	"mrm_confirming": "Confirming...",
	"mrm_confirm_reservation_button": "Confirm Reservation",
	"mrm_fill_all_date_time_fields": "Please fill in all date/time fields",
	"mrm_room_booked_success": "Room booked successfully!",
	"mrm_room_booking_failed": "Failed to book room",
	"mrm_confirmation_failed": "Unable to confirm the room",
	"mrm_no_event_to_confirm": "No event to confirm",
	"mrm_try_again_later": "Please try again later.",
	"roles": "Roles",
	"assigned_access": "Assigned access",
	"my_roles": "My roles",
	"no_role_assigned": "No role assigned",
	"role_admin": "Administrator",
	"role_communicator": "Communicator",
	"role_site_manager": "Site Manager",
	"role_support": "Support",
	"role_teammate": "Teammate"
}
